import { axios } from '@/utils/request'

const api = {
  template: '/basicdata/template',
  orderType: '/basicdata/orderType',
  type: '/system/dict/type',
  info: '/basicdata/info/',
}

// 导出
export function InfoTemplate (parameter) {
  return axios({
    url: '/basicdata/template/exportInstallationInfoTemplate',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })
}

export function getSelectList (parameter) {
  return axios({
    url: api.info + '/selectList',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function updateITI (parameter) {
  return axios({
    url: api.template + '/updateITI',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 模板list
export function getTemplateList (parameter) {
  return axios({
    url: api.template + '/list',
    method: 'get',
    params: parameter
  })
}
// 安装信息
export function InfoList (parameter) {
  return axios({
    url: api.info + '/list',
    method: 'get',
    params: parameter
  })
}
// 排序
export function updateSort (parameter) {
  return axios({
    url: '/basicdata/template/updateSort',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 新增页面的list
export function getInfoList (parameter) {
  return axios({
    url: api.template + `/infoList/${parameter}`,
    method: 'get',
  })
}

// 订单类型下拉
export function getOrderTypeList (parameter) {
  return axios({
    url: api.orderType + `/getList/${parameter}`,
    method: 'get',
  })
}

export function save (parameter) {
  return axios({
    url: api.template + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function update (parameter) {
  return axios({
    url: api.template + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function remove (parameter) {
  return axios({
    url: api.template + '/remove',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getList (parameter) {
  return axios({
    url: api.type + '/list',
    method: 'get',
    params: parameter
  })
}

export const fieldType = {
  '0': '单选框',
  '1': '输入框',
  '3': '单选+输入'
}

export const statuType = {
  '0': '启用',
  '1': '禁用',
}

export const isTrueType = {
  '0': '是',
  '1': '否',
}

export const channelExport = api.channel + '/export'
